// import { useEffect, useState } from "react";
// import { generateTaskReport } from "../../../api/reports/hrm/tasks_report_info"; 
// import { getEmployeesFilter } from "../../../api/hrm/employees/employeeInfo";
// import { showSuccessToast, showErrorToast } from "../../../components/ConfirmDialog";
// import dayjs from "dayjs";
// import isoWeek from "dayjs/plugin/isoWeek";
// import Select from "react-select";
// import customSelectStyles from "../../../components/ui/customSelectStyles";
// import { hasPermission } from "../../../utils/permissionUtils";
// import { getTasksByEmployeeByRange } from "../../../api/hrm/tasks/task_info";
// import Spinner from "../../../components/ui/Spinner";


// dayjs.extend(isoWeek);

// function TaskReportCreate({ onClose, onSaved }) {
//   const [currentUser, setCurrentUser] = useState(null);
//   const [employeeList, setEmployeeList] = useState([]);
//   const [employeeId, setEmployeeId] = useState("");
//   const [employeeName, setEmployeeName] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [summary, setSummary] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [taskList, setTaskList] = useState([]);
//   const [loadingTasks, setLoadingTasks] = useState(false);


//   const canSelectEmployee = hasPermission("hrm.tasks", "A");


//   useEffect(() => {
//     setTaskList([]);          // clear danh sách công việc
//     setSummary("");           // clear nội dung tổng kết
//   }, [employeeId, fromDate, toDate]);

//   // 🌟 1) Load current user
//   useEffect(() => {
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       const user = JSON.parse(storedUser);
//       setCurrentUser(user);

//       // set mặc định để tránh lỗi ban đầu
//       setEmployeeId(user.id);
//       setEmployeeName(user.name);
//     }
//   }, []);

//   // 🌟 2) Khi currentUser load xong → gọi API lấy danh sách nhân viên theo phân quyền
//   useEffect(() => {
//     const loadEmployees = async () => {
//       if (!currentUser) return;
  
//       try {
//         let filter = {};
//         const roles = currentUser.roles?.map(r => r.toLowerCase()) || [];
  
//         // 1) SUPER ADMIN / CEO / COO → full quyền
//         if (
//           roles.includes("super admin") ||
//           roles.includes("tổng giám đốc") ||
//           roles.includes("giám đốc điều hành")
//         ) {
//           filter = {}; // lấy toàn bộ
//         }
  
//         // 2) GIÁM ĐỐC CHI NHÁNH
//         else if (roles.includes("giám đốc chi nhánh")) {
//           filter.branch_id = currentUser.branch?.id;
//         }
  
//         // 3) HEAD / DIRECTOR (trưởng phòng / giám đốc bộ phận)
//         else if (
//           roles.some(r => r.includes("trưởng") || r.includes("giám đốc"))
//         ) {
//           filter.department_id = currentUser.department_id;
//         }
  
//         // 4) NHÂN VIÊN THƯỜNG
//         else {
//           setEmployeeList([]);
//           return;
//         }
  
//         const res = await getEmployeesFilter(filter);
//         setEmployeeList(res);
//         console.log("📌 FE nhận danh sách nhân viên:", res);
  
//       } catch (err) {
//         console.error("Lỗi load danh sách nhân viên:", err);
//       }
//     };
  
//     loadEmployees();
//   }, [currentUser]);
  

//   // Khi employeeList đã load xong → cập nhật lại nhân viên mặc định
//   useEffect(() => {
//     if (!currentUser) return;

//     // Nếu user không có quyền chọn nhân viên → auto set chính họ
//     if (!canSelectEmployee) {
//       setEmployeeId(currentUser.id);
//       setEmployeeName(currentUser.name);
//     }
//   }, [employeeList, currentUser]);

//   // Set mặc định: Thứ 2 → Thứ 7 tuần hiện tại
//   useEffect(() => {
//     const monday = dayjs().isoWeekday(1).format("YYYY-MM-DD"); // Thứ 2
//     const saturday = dayjs().isoWeekday(6).format("YYYY-MM-DD"); // Thứ 7

//     setFromDate(monday);
//     setToDate(saturday);
//   }, []);
    
//   const employeeOptions = employeeList.map((e) => ({
//     value: e.id,
//     // label: `${e.employee_name} – ${e.branch_name || ""}`,
//     label: `${e.employee_name} (${e.branch_name || "Không chi nhánh"})`,

//   }));

//   // Load danh sách công việc theo khoảng ngày
//   const handleLoadTasks = async () => {
//     if (!employeeId || !fromDate || !toDate) {
//       showErrorToast("Vui lòng chọn nhân viên và khoảng ngày");
//       return;
//     }
  
//     try {
//       setLoadingTasks(true);
//       const data = await getTasksByEmployeeByRange(employeeId, fromDate, toDate);
//       setTaskList(data);
//     } catch (err) {
//       showErrorToast("Không thể tải công việc");
//     } finally {
//       setLoadingTasks(false);
//     }
//   };


//   const groupedTasks = taskList.reduce((acc, t) => {
//     const d = dayjs(t.work_day).format("DD [Th]MM YYYY");
//     if (!acc[d]) acc[d] = [];
//     acc[d].push(t);
//     return acc;
//   }, {});
  
  

//   // 🌟 3) Submit form
//   const handleSubmit = async () => {
//     if (!fromDate || !toDate) {
//       showErrorToast("Vui lòng chọn đầy đủ thời gian báo cáo!");
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         employee_id: employeeId,
//         from_date: fromDate,
//         to_date: toDate,
//         report_summary: summary || "",
//         tasks: taskList,
//       };

//       const res = await generateTaskReport(payload);

//       showSuccessToast("Tạo báo cáo thành công!");
//       onSaved?.(res);
//       onClose?.();

//     } catch (err) {
//       console.error("❌ Tạo báo cáo lỗi:", err);
//       showErrorToast(err?.message || "Không thể tạo báo cáo!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="max-w-[95%] w-[500px] bg-white rounded-xl p-6 shadow">
//       <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
//         <span className="text-red-500 text-lg">📄</span> Tạo báo cáo công việc
//       </h2>

//       {/* ============================
//           1. Nhân viên
//       ============================ */}
//       <div className="mb-4">
//         <label className="text-sm font-medium block mb-1">Nhân viên <span className="text-red-500">*</span></label>

//         {canSelectEmployee ? (
//           <Select
//             value={employeeList.find(e => e.id === employeeId) || null}
//             onChange={(opt) => {
//               setEmployeeId(opt.id);
//               setEmployeeName(opt.employee_name);
//             }}
//             options={employeeList}
//             getOptionLabel={(opt) => `${opt.employee_name} — ${opt.branch_name}`}
//             getOptionValue={(opt) => opt.id}
//             isDisabled={!canSelectEmployee}
//             placeholder="Chọn nhân viên..."
//             styles={customSelectStyles}
//           />
//         ) : (
//           <input
//             type="text"
//             value={employeeName}
//             disabled
//             className="w-full border rounded px-3 py-2 bg-gray-100 text-gray-700"
//           />
//         )}
//       </div>

//       {/* ============================
//           2. Từ ngày - Đến ngày (1 hàng)
//       ============================ */}
//       <div className="grid grid-cols-2 gap-4 mb-4">
//         <div>
//           <label className="text-sm font-medium block mb-1">Từ ngày <span className="text-red-500">*</span></label>
//           <input
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             className="w-full border rounded px-3 py-2"
//           />
//         </div>

//         <div>
//           <label className="text-sm font-medium block mb-1">Đến ngày <span className="text-red-500">*</span></label>
//           <input
//             type="date"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//             className="w-full border rounded px-3 py-2"
//           />
//         </div>
//       </div>

//       <button
//         type="button"
//         onClick={handleLoadTasks}
//         className="px-3 py-2 bg-gray-200 border border-gray-300 text-gray-800 rounded-md font-semibold text-sm hover:bg-gray-300 transition w-full"
//       >
//         Xem danh sách công việc
//       </button>

//       {/* Danh sách công việc */}
//       {loadingTasks && (
//         <div className="mt-4">
//           <Spinner />
//         </div>
//       )}

//       {!loadingTasks && taskList.length > 0 && (
//         <div className="mt-4">

//           {/* KHUNG PREVIEW */}
//           <div className="
//             border rounded-lg bg-gray-50 
//             px-4 py-3 
//             max-h-64 overflow-y-auto 
//             shadow-sm
//           ">

//             <div className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
//               📋 Danh sách công việc ({taskList.length})
//             </div>

//             <div className="space-y-4">
//               {Object.keys(groupedTasks).map((day) => (
//                 <div key={day} className="pb-2 border-b last:border-none">

//                   {/* Ngày */}
//                   <div className="font-semibold text-gray-700 mb-1">
//                     [{day}]
//                   </div>

//                   {/* Tasks trong ngày */}
//                   <div className="space-y-3">
//                     {groupedTasks[day].map((t) => (
//                       <div key={t.id}>
//                         {/* Tên công việc */}
//                         <div className="text-sm text-gray-800 leading-snug">
//                           • {t.taskname}
//                         </div>

//                         {/* Báo cáo */}
//                         <div className="text-xs text-gray-600 ml-4 border-l pl-2 italic">
//                           {t.reports?.[0]?.report_content || "—"}
//                         </div>
//                       </div>
//                     ))}
//                   </div>

//                 </div>
//               ))}
//             </div>

//           </div>
//           {/* END KHUNG */}
//         </div>
//       )}


//       {/* ============================
//           3. Tóm tắt báo cáo
//       ============================ */}
//       <div className="mb-4 mt-4">
//         <label className="text-sm font-medium block mb-1">
//           Tóm tắt báo cáo (nội dung chính)
//         </label>

//         <textarea
//           rows={4}
//           value={summary}
//           onChange={(e) => {
//             let text = e.target.value;

//             // Auto-trim khi paste quá 500 ký tự
//             if (text.length > 500) {
//               text = text.slice(0, 500);
//             }

//             setSummary(text);
//           }}
//           placeholder="Nhập nội dung tổng kết..."
//           className={`
//             w-full border rounded px-3 py-2 transition-all
//             ${summary.length >= 450 ? "border-red-400" : "border-gray-300"}
//             focus:outline-none focus:ring-2 
//             ${summary.length >= 450 ? "focus:ring-red-300" : "focus:ring-gray-300"}
//           `}
//         />

//         {/* Đếm ký tự nâng cấp */}
//         <div
//           className={`text-right text-xs mt-1 transition-all
//             ${summary.length >= 450 ? "text-red-500 font-medium" : "text-gray-500"}
//           `}
//         >
//           {summary.length}/500 ký tự
//           {summary.length >= 450 && (
//             <span className="ml-1">(Gần đạt giới hạn!)</span>
//           )}
//         </div>
//       </div>



//       {/* ============================
//           4. Buttons
//       ============================ */}
//       <div className="flex justify-end gap-3 mt-6">
//         <button
//           onClick={onClose}
//           className="px-5 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
//         >
//           Hủy
//         </button>

//         <button
//           onClick={handleSubmit}
//           disabled={loading}
//           className="px-6 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 flex items-center justify-center gap-2 min-w-[130px]"
//         >
//           {loading ? (
//             <>
//               <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
//               Đang tạo...
//             </>
//           ) : (
//             "Tạo báo cáo"
//           )}
//         </button>
//       </div>
//     </div>
//   );
// }

// export default TaskReportCreate;












import { useEffect, useState } from "react";
import { 
  X, User, Calendar, ClipboardList, 
  Send, Search, CheckCircle2, Paperclip
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import Select from "react-select";
import customSelectStyles from "../../../components/ui/customSelectStyles";
import dayjs from "../../../utils/dayjs";
import { generateTaskReport } from "../../../api/reports/hrm/tasks_report_info";
import { getEmployeesFilter } from "../../../api/hrm/employees/employeeInfo";
import { getTasksByEmployeeByRange } from "../../../api/hrm/tasks/task_info";
import { showSuccessToast, showErrorToast } from "../../../components/ConfirmDialog";
import { hasPermission } from "../../../utils/permissionUtils";
import Spinner from "../../../components/ui/Spinner";

function TaskReportCreate({ onClose, onSaved, isOpen }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [summary, setSummary] = useState("");
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [loadingTasks, setLoadingTasks] = useState(false);

  const canSelectEmployee = hasPermission("hrm.tasks", "A");

  // Logic dữ liệu (Giữ nguyên logic của bạn)
  useEffect(() => {
    setTaskList([]);
    setSummary("");
    setAttachmentFile(null);
  }, [employeeId, fromDate, toDate]);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      setCurrentUser(user);
      setEmployeeId(user.id);
      setEmployeeName(user.name);
    }
  }, []);

  useEffect(() => {
    const loadEmployees = async () => {
      if (!currentUser) return;
      try {
        let filter = {};
        const roles = currentUser.roles?.map(r => r.toLowerCase()) || [];
        if (roles.includes("super admin") || roles.includes("tổng giám đốc") || roles.includes("giám đốc điều hành")) {
          filter = {};
        } else if (roles.includes("giám đốc chi nhánh")) {
          filter.branch_id = currentUser.branch?.id;
        } else if (roles.some(r => r.includes("trưởng") || r.includes("giám đốc"))) {
          filter.department_id = currentUser.department_id;
        } else {
          setEmployeeList([]);
          return;
        }
        const res = await getEmployeesFilter(filter);
        setEmployeeList(res);
      } catch (err) {
        console.error("Lỗi load danh sách nhân viên:", err);
      }
    };
    loadEmployees();
  }, [currentUser]);

  useEffect(() => {
    const monday = dayjs().isoWeekday(1).format("YYYY-MM-DD");
    const saturday = dayjs().isoWeekday(6).format("YYYY-MM-DD");
    setFromDate(monday);
    setToDate(saturday);
  }, []);

  const handleLoadTasks = async () => {
    if (!employeeId || !fromDate || !toDate) {
      showErrorToast("Vui lòng chọn nhân viên và khoảng ngày");
      return;
    }
    try {
      setLoadingTasks(true);
      const data = await getTasksByEmployeeByRange(employeeId, fromDate, toDate);
      setTaskList(data);
    } catch (err) {
      showErrorToast("Không thể tải công việc");
    } finally {
      setLoadingTasks(false);
    }
  };

  const groupedTasks = taskList.reduce((acc, t) => {
    const d = dayjs(t.work_day).format("DD [Th]MM YYYY");
    if (!acc[d]) acc[d] = [];
    acc[d].push(t);
    return acc;
  }, {});

  const limitSummary = (value) => value.slice(0, 250);

  const handleAttachmentChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setAttachmentFile(null);
      return;
    }

    const isPdfType = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
    if (!isPdfType) {
      showErrorToast("Chỉ chấp nhận file PDF.");
      e.target.value = "";
      return;
    }

    setAttachmentFile(file);
  };

  const handleSubmit = async () => {
    if (!fromDate || !toDate) {
      showErrorToast("Vui lòng chọn đầy đủ thời gian báo cáo!");
      return;
    }
    try {
      setLoading(true);
      let payload;
      if (attachmentFile) {
        payload = new FormData();
        payload.append("employee_id", employeeId);
        payload.append("from_date", fromDate);
        payload.append("to_date", toDate);
        payload.append("report_summary", summary || "");
        payload.append("tasks", JSON.stringify(taskList));
        payload.append("report_attachment", attachmentFile);
      } else {
        payload = {
          employee_id: employeeId,
          from_date: fromDate,
          to_date: toDate,
          report_summary: summary || "",
          tasks: taskList,
        };
      }
      const res = await generateTaskReport(payload);
      showSuccessToast("Tạo báo cáo thành công!");
      onSaved?.(res);
      onClose?.();
    } catch (err) {
      showErrorToast(err?.message || "Không thể tạo báo cáo!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          onClick={(e) => e.stopPropagation()}
          className="bg-white w-full max-w-2xl rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[95vh]"
        >
          {/* Header */}
          <div className="relative p-6 border-b border-gray-100 flex items-center justify-between bg-white">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center border border-red-100 shadow-sm">
                <ClipboardList size={24} />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-800">Tạo báo cáo công việc</h2>
                <p className="text-xs text-gray-500">Tổng hợp dữ liệu và gửi báo cáo định kỳ</p>
              </div>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 text-gray-400 hover:text-gray-600 rounded-full transition-all">
              <X size={24} />
            </button>
          </div>

          {/* Form Content */}
          <div className="flex-1 overflow-y-auto p-8 custom-scrollbar space-y-8">
            
            {/* 1. Chọn nhân viên & Thời gian */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="col-span-full">
                <h3 className="text-[11px] font-black text-red-500 uppercase tracking-widest mb-4 flex items-center gap-2">
                  <div className="w-1 h-4 bg-red-500 rounded-full" /> 1. Thông tin nhân sự
                </h3>
                <div className="relative group">
                  <div className="absolute left-3 top-1/2 -translate-y-1/2 z-10 text-gray-400 group-focus-within:text-red-500 transition-colors">
                    <User size={18} />
                  </div>
                  {canSelectEmployee ? (
                    <div className="pl-8">
                       <Select
                        value={employeeList.find(e => e.id === employeeId) || null}
                        onChange={(opt) => {
                          setEmployeeId(opt.id);
                          setEmployeeName(opt.employee_name);
                        }}
                        options={employeeList}
                        getOptionLabel={(opt) => `${opt.employee_name} — ${opt.branch_name}`}
                        getOptionValue={(opt) => opt.id}
                        placeholder="Chọn nhân viên lập báo cáo..."
                        styles={{
                          ...customSelectStyles,
                          control: (base) => ({
                            ...base,
                            paddingLeft: '24px',
                            borderRadius: '12px',
                            borderColor: '#f1f5f9'
                          })
                        }}
                      />
                    </div>
                  ) : (
                    <input
                      type="text"
                      value={employeeName}
                      disabled
                      className="w-full bg-gray-50 border border-gray-100 rounded-xl py-3 pl-11 pr-4 text-sm font-semibold text-gray-700"
                    />
                  )}
                </div>
              </div>

              <div>
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-tight ml-1 mb-1 block">Từ ngày</label>
                <div className="relative">
                  <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="w-full bg-gray-50 border border-gray-100 rounded-xl py-2.5 pl-10 pr-4 text-sm focus:ring-2 focus:ring-red-100 outline-none transition-all"
                  />
                </div>
              </div>

              <div>
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-tight ml-1 mb-1 block">Đến ngày</label>
                <div className="relative">
                  <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    className="w-full bg-gray-50 border border-gray-100 rounded-xl py-2.5 pl-10 pr-4 text-sm focus:ring-2 focus:ring-red-100 outline-none transition-all"
                  />
                </div>
              </div>
            </div>

            {/* 2. Load Tasks Preview */}
            <div className="space-y-4">
              <button
                type="button"
                onClick={handleLoadTasks}
                className="w-full py-3 bg-slate-800 text-white rounded-xl font-bold text-sm flex items-center justify-center gap-2 hover:bg-slate-900 transition-all shadow-lg shadow-slate-200"
              >
                <Search size={18} /> TRUY XUẤT DANH SÁCH CÔNG VIỆC
              </button>

              {loadingTasks && <div className="flex justify-center py-4"><Spinner /></div>}

              {!loadingTasks && taskList.length > 0 && (
                <div className="bg-gray-50/50 rounded-2xl border border-dashed border-gray-200 p-5 space-y-4">
                  <h4 className="text-xs font-bold text-gray-600 flex items-center justify-between">
                    DỮ LIỆU CÔNG VIỆC TÌM THẤY <span>{taskList.length} đầu việc</span>
                  </h4>
                  <div className="space-y-5 max-h-60 overflow-y-auto pr-2 custom-scrollbar">
                    {Object.keys(groupedTasks).map((day) => (
                      <div key={day} className="relative pl-4 border-l-2 border-red-200">
                        <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-white border-4 border-red-500" />
                        <span className="text-[10px] font-black text-red-500 uppercase tracking-tighter block mb-2">{day}</span>
                        <div className="space-y-3">
                          {groupedTasks[day].map((t) => (
                            <div key={t.id} className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm">
                              <p className="text-sm font-bold text-gray-700 flex items-center gap-2">
                                <CheckCircle2 size={14} className="text-green-500" /> {t.taskname}
                              </p>
                              <p className="text-[11px] text-gray-500 mt-1 italic pl-5 leading-relaxed">
                                {t.reports?.[0]?.report_content || "Không có nội dung báo cáo chi tiết"}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* 3. File đính kèm + tóm tắt thủ công */}
            <div className="space-y-3">
              <h3 className="text-[11px] font-black text-red-500 uppercase tracking-widest flex items-center gap-2">
                <div className="w-1 h-4 bg-red-500 rounded-full" /> 2. Tóm tắt báo cáo
              </h3>

              <label className="block">
                <div className="w-full bg-gray-50 border border-gray-100 rounded-2xl px-4 py-3 text-sm flex items-center gap-2 cursor-pointer hover:bg-gray-100 transition-all">
                  <Paperclip size={16} className="text-gray-500" />
                  <span className="text-gray-700">
                    {attachmentFile ? attachmentFile.name : "Chọn file đính kèm PDF (không bắt buộc)"}
                  </span>
                </div>
                <input
                  type="file"
                  accept="application/pdf,.pdf"
                  onChange={handleAttachmentChange}
                  className="hidden"
                />
              </label>

              <p className="text-xs text-gray-500">
                File đính kèm PDF là tùy chọn. Nội dung tóm tắt nhập tay, tối đa 250 ký tự (không bắt buộc).
              </p>

              <div className="relative">
                <div className="absolute right-3 bottom-3 text-[10px] font-bold text-gray-400">
                  {summary.length}/250
                </div>
                <textarea
                  rows={4}
                  value={summary}
                  onChange={(e) => setSummary(limitSummary(e.target.value))}
                  placeholder="Nhập nội dung tóm tắt báo cáo (không bắt buộc)..."
                  className="w-full bg-gray-50 border border-gray-100 rounded-2xl p-4 text-sm focus:ring-2 focus:ring-red-100 outline-none transition-all resize-none"
                />
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="p-6 border-t border-gray-50 bg-gray-50/30 flex justify-end gap-3">
            <button onClick={onClose} className="px-6 py-3 rounded-xl font-bold text-gray-500 hover:bg-gray-100 transition-all">
              HỦY BỎ
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl flex items-center gap-2 shadow-lg shadow-red-100 transition-all active:scale-95 disabled:opacity-50"
            >
              {loading ? <Spinner size="sm" /> : <><Send size={18} /> GỬI BÁO CÁO</>}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

export default TaskReportCreate;